import { useEffect, useState } from "react";

export const GlassCard = ({ className = "", gold = false, hover = false, children, ...p }) => (
  <div className={`v2-glass ${gold ? "v2-glass-gold" : ""} ${hover ? "v2-hover" : ""} ${className}`} {...p}>
    {children}
  </div>
);

export const Ring = ({ value = 0, size = 132, stroke = 12, children, id = "v2grad", fail = false }) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (Math.max(0, Math.min(100, value)) / 100) * c;
  return (
    <div style={{ width: size, height: size }} className="relative inline-flex items-center justify-center">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e3e7ea" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={fail ? "#a83e1e" : "#bb9661"} strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset .9s cubic-bezier(.2,.7,.3,1)" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">{children}</div>
    </div>
  );
};

export const CountUp = ({ value = 0, dur = 1100, className = "" }) => {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf, start;
    const to = Number(value) || 0;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min(1, (t - start) / dur);
      setN(Math.round(to * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value, dur]);
  return <span className={className}>{n}</span>;
};

export const Bar = ({ value = 0, className = "" }) => (
  <div className={`w-full h-2.5 rounded-full bg-surface-3 overflow-hidden ${className}`}>
    <div className="h-full rounded-full" style={{ width: `${Math.max(0, Math.min(100, value))}%`, background: "#bb9661", transition: "width .8s cubic-bezier(.2,.7,.3,1)" }} />
  </div>
);

export const Chip = ({ children, tone = "emerald", className = "" }) => {
  const tones = {
    emerald: "text-ok bg-ok/12 border-ok/25",
    gold: "text-beige-ink bg-beige/12 border-beige/30",
    muted: "text-ink-2 bg-surface-2 border-line",
    red: "text-danger bg-danger/15 border-danger/30",
    sky: "text-ink-2 bg-[#5b8fc7]/15 border-[#5b8fc7]/30",
  };
  return <span className={`inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full border ${tones[tone]} ${className}`}>{children}</span>;
};

export const Skeleton = ({ className = "" }) => <div className={`v2-skel ${className}`} />;

export const Confetti = () => {
  const colors = ["#bb9661", "#006654", "#bb9661", "#25343f"];
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {Array.from({ length: 46 }).map((_, i) => (
        <span key={i} className="v2-confetti absolute w-2 h-3 rounded-sm"
          style={{ left: `${Math.random() * 100}%`, top: "-12px", background: colors[i % 4], animationDelay: `${Math.random() * 0.6}s` }} />
      ))}
    </div>
  );
};

